// Hooks
import { useHideCollectionsSetting } from 'modules/collections/hooks'
import { useSortingSettings } from 'modules/shares/hooks/useSortSettings'

// GraphQL
import { useGetProjectSharesQuery } from '@sketch/gql-types'

// Types
import { ShareSearchFilter } from 'modules/shares/hooks/useSearchFilters'

interface UseGetProjectSharesProps {
  projectIdentifier: string
  searchTerm?: string
  filters: ShareSearchFilter[]
}

export const useGetProjectShares = ({
  projectIdentifier,
  searchTerm,
  filters: baseFilters,
}: UseGetProjectSharesProps) => {
  const { hideCollections } = useHideCollectionsSetting()
  const { sort } = useSortingSettings()

  // the `NO_COLLECTION` filter will make sure that only shares outside of
  // collections are returned.
  const includeNoCollectionsFilter = !hideCollections

  const filters = [...baseFilters]
  if (includeNoCollectionsFilter) {
    filters.push('NO_COLLECTION')
  }

  return useGetProjectSharesQuery({
    variables: {
      shortId: projectIdentifier,
      after: null,
      search: {
        name: searchTerm || null,
        isCurrentVersionDownloadable: null,
        filters,
      },
      sortOrder: sort,
    },
    shouldInvalidatePrevious: (prev, curr) => prev?.shortId !== curr?.shortId,
  })
}
